import { getStarterKit, getItem } from './contentRegistry';

// Resolve a starter-kit id into the items it grants, then optionally
// identify the best armor / weapon / shield for AC + initiative math.
//
// Returns:
//   {
//     items: [{ id, name, kind, quantity, ... }],
//     equippedArmor: { id, name, baseAc, dexCap, ... } | null,
//     equippedShield: { id, name, acBonus } | null,
//     equippedWeapon: { id, name, ... } | null,
//     currency: [{ value, denom }],
//   }
//
// Future phases let the player swap equipment; Phase 2 follows the kit.

const isShield = (item) =>
  item?.kind === 'shield' || item?.id === 'srd.shield.shield' || /shield/i.test(item?.id || '');

export const applyEquipment = (starterKitId) => {
  const kit = getStarterKit(starterKitId);
  if (!kit) {
    return { items: [], equippedArmor: null, equippedShield: null, equippedWeapon: null, currency: [] };
  }

  const items = [];
  const currency = [];

  for (const grant of kit.grants || []) {
    if (grant.kind === 'currency') {
      currency.push({ value: grant.value, denom: grant.denom });
      continue;
    }
    if (grant.kind !== 'item') continue;
    const data = getItem(grant.id);
    if (!data) {
      // Unauthored item — preserve the id so future content additions can
      // resolve it without losing the grant.
      items.push({ id: grant.id, name: grant.id, kind: 'unknown', quantity: grant.quantity || 1 });
      continue;
    }
    items.push({ ...data, quantity: grant.quantity || 1 });
  }

  const equippedArmor = items.find((i) => i.kind === 'armor') || null;
  const equippedShield = items.find(isShield) || null;
  const equippedWeapon = items.find((i) => i.kind === 'weapon') || null;

  return {
    items,
    equippedArmor,
    equippedShield,
    equippedWeapon,
    currency,
  };
};
